import { Button, Collapse, Space } from 'antd';
import { PermissionsGroup } from './permissions-group';
import { parsePermissions } from 'services/permissions';
import { useMemo, useState } from 'react';
import { usePermissions } from 'hooks/usePermissions';

interface PermissionsProps {
  permissions: string[];
  disabled?: boolean;
  onChange?: (permissions: string[]) => void;
}

export const Permissions = ({
  permissions,
  disabled,
  onChange
}: PermissionsProps) => {
  const permissionsList = useMemo(() => parsePermissions(), []);
  const [activeKeys, setActiveKeys] = useState<string[]>([]);

  const { selectedPermission, toggleAllPermissions, togglePermission } =
    usePermissions(permissions, permissionsList, disabled, onChange);

  const allPermissionKeys = useMemo(
    () => permissionsList.map(permission => permission.name),
    [permissionsList]
  );

  const handleCollapseChange = (keys: string | string[]) => {
    setActiveKeys(Array.isArray(keys) ? keys : [keys]);
  };

  const expandAll = () => {
    setActiveKeys(allPermissionKeys);
  };

  const collapseAll = () => {
    setActiveKeys([]);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%'
      }}
    >
      <Space>
        <Button size="small" onClick={expandAll}>
          Expandir todos
        </Button>
        <Button size="small" onClick={collapseAll}>
          Recolher todos
        </Button>
      </Space>

      <Collapse
        activeKey={activeKeys}
        onChange={handleCollapseChange}
        expandIconPosition="end"
        bordered
      >
        {permissionsList.map(permission => (
          <PermissionsGroup
            key={permission.name}
            permission={permission}
            selectedPermission={selectedPermission}
            onToggleAll={toggleAllPermissions}
            onTogglePermission={togglePermission}
            disabled={disabled}
          />
        ))}
      </Collapse>
    </div>
  );
};
